import { Radio } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import type { FC } from "react";

import type { SeasonTaskSubmissionMode } from "../../../types/gamePass";
import { AppStrings } from "../../../utils/constants/AppStrings";

import styles from "./SubmissionModeField.module.css";

export type SubmissionModeFieldProps = {
  label: string;
  infoAria: string;
  testIdPrefix: string;
  fieldId: string;
  value: SeasonTaskSubmissionMode;
  disabled?: boolean;
  manualDisabled?: boolean;
  onChange?: (mode: SeasonTaskSubmissionMode) => void;
};

const SubmissionModeField: FC<SubmissionModeFieldProps> = ({
  label,
  infoAria,
  testIdPrefix,
  fieldId,
  value,
  disabled = false,
  manualDisabled = false,
  onChange,
}) => (
  <div className={styles.field}>
    <span className={styles.fieldLabel}>
      {label}
      <InfoCircleOutlined
        className={styles.fieldInfoIcon}
        role="img"
        aria-label={infoAria}
        data-testid={`${testIdPrefix}-${fieldId}-info`}
      />
    </span>
    <Radio.Group
      className={styles.modeRow}
      value={value}
      disabled={disabled}
      onChange={(e) =>
        onChange?.(e.target.value as SeasonTaskSubmissionMode)
      }
    >
      <label
        className={styles.modeLabel}
        data-testid={`${testIdPrefix}-${fieldId}-auto-label`}
      >
        <Radio
          value="AUTO"
          data-testid={`${testIdPrefix}-${fieldId}-auto`}
        />
        <span>{AppStrings.CREATE_SEASON_TASK_SUBMISSION_AUTO}</span>
      </label>
      <label
        className={
          manualDisabled
            ? `${styles.modeLabel} ${styles.modeLabelDisabled}`
            : styles.modeLabel
        }
        data-testid={`${testIdPrefix}-${fieldId}-manual-label`}
      >
        <Radio
          value="MANUAL"
          // antd resolves a Radio's own `disabled` before the group's
          // (`disabled ?? groupContext.disabled`), so an explicit `false` here
          // would re-enable Manual inside a read-only group. OR both props so a
          // read-only field (View/locked season, task view mode) always keeps
          // Manual disabled, while manual-only locks (casino) still apply.
          disabled={manualDisabled || disabled}
          data-testid={`${testIdPrefix}-${fieldId}-manual`}
        />
        <span>{AppStrings.CREATE_SEASON_TASK_SUBMISSION_MANUAL}</span>
      </label>
    </Radio.Group>
  </div>
);

export default SubmissionModeField;
